import List from "@/components/menuTreeList";
import Bus from "./Bus.js";
import { tableBaseProps } from '@/utils/common.js';

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  function handleUpdate({ row }) {
    Bus.$emit("ReceiveMessage", Object.assign({}, row));
  }
  //删除
  function handleDelete({ row }) {
    Bus.$emit("deleteMenu", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "menu:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "menu:delete"]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const MenuPermissions = ({ props: { vo } }) => {
    const menuPermissions = vo.row.menuPermissions
      ? vo.row.menuPermissions
      : "--";
    return <span>{menuPermissions}</span>;
  };
  const MenuUrl = ({ props: { vo } }) => {
    const menuUrl = vo.row.menuUrl ? vo.row.menuUrl : "--";
    return <span>{menuUrl}</span>;
  };

  const IsKeepAlive = ({ props: { vo } }) => {
    const row = vo.row
    return <span>{!!row.keepAlive ? '是' : '否'}</span>
  }

  const AccountTableConfig = [
    tableBaseProps("菜单名", "menuName", "m120"),
    tableBaseProps("菜单类型", "menuTypeName", "m100"),
    {
      ...tableBaseProps("授权标识", "menuPermissions", "m100"),
      render: vo => <MenuPermissions vo={vo} />
    },
    {
      ...tableBaseProps("URL", "menuUrl", "m100"),
      render: vo => <MenuUrl vo={vo} />
    },
    {
      ...tableBaseProps("是否缓存", "keepAlive", "80"),
      render: vo => <IsKeepAlive vo={vo} />
    },
    tableBaseProps("排序", "order", "80"),
    tableBaseProps("创建时间", "createDate", "160"),
    {
      label: "操作",
      fixed: "right",
      minWidth: "100",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
